<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Your Profile</h1>
            </v-flex>
            <v-flex xs6 class="text-right">
                <v-btn color="primary" depressed dark @click="passwordReset()">Reset Password</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        label="First name"
                                        v-model="currentUser.firstName">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Last name"
                                        v-model="currentUser.lastName"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Email"
                                        v-model="currentUser.email">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Phone"
                                        v-model="currentUser.phoneNumber">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="accent" dark depressed block @click="updateUser">Save</v-btn>
                    </v-card-actions>
                    <v-alert v-if="this.error != null" dismissible color="error" dark>
                        <v-icon size="20" dark>warning</v-icon>{{this.error}}
                    </v-alert>
                </v-card>
            </v-flex>
        </v-layout>

        <password-reset
            :showDialog="passwordDialog"
            :toggle="togglePassword"
            :user="userForPassword">
        </password-reset>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import PasswordReset from '@/components/users/ResetPassword'
    export default {
        name: 'profile',
        components: {
            PasswordReset
        },
        data () {
            return {
                passwordDialog: false,
                index: null,
                userForPassword: {},
            }
        },
        methods: {
            ...mapActions({
                update: 'user/updateUser',
            }),
            togglePassword () {
                this.passwordDialog = !(this.passwordDialog)
            },
            passwordReset() {
                this.userForPassword.email = this.currentUser.email
                this.togglePassword()
            },
            updateUser() {
                this.update({
                    role: -1, //don't change the role
                    id: this.currentUser.id,
                    email: this.currentUser.email,
                    firstName: this.currentUser.firstName,
                    lastName: this.currentUser.lastName,
                    phoneNumber: this.currentUser.phoneNumber
                })
            }
        },
        computed: {
            ...mapGetters({
                currentUser: 'user/currentUser',
                error: 'user/error'
            }),

        }
    }
</script>
